export const tourText = {
  libraryOverview: {
    title: 'Your library',
    description: 'Manage all uploaded content here.',
  },
  libraryUpload: {
    title: 'Upload files',
    description: 'Click here to upload new files.',
  },
  librarySearch: {
    title: 'Search library',
    description: 'Find files quickly using the search.',
  },
};
